export var DATA_HOOKS = /*#__PURE__*/ function(DATA_HOOKS) {
    DATA_HOOKS["FORM_ROOT"] = "form-root";
    DATA_HOOKS["FORM_VIEWER_NO_FORM_ERROR"] = "form-viewer-no-form-error";
    DATA_HOOKS["SUBMIT_THANK_YOU_MESSAGE"] = "submit-form-success-message";
    DATA_HOOKS["SUBMIT_ERROR_MESSAGE"] = "submit-form-error-message";
    DATA_HOOKS["FORM_CLOSED_MESSAGE"] = "form-closed-message";
    return DATA_HOOKS;
}({});

//# sourceMappingURL=data-hooks.js.map